import React, { useEffect, useState } from "react";

import BlogItem from "./../BlogItem";
import Pagination from "./../../../../Elements/Pagination";
import { Heading, BlogListWrapper } from "./style";

import { getStoriesByContentType } from "@website-builder/services";
import {
	contentType,
	getBlogItemProps,
	filterBlogsByCategories,
} from "./transform";
import { ORDER_BY } from "@website-builder/utilities-index";
import { sortNumberBy } from "@website-builder/utilities-index";

const BlogList = ({
	blogList = [],
	header,
	blogsPerPage = 5,
	allowTitleNavigation,
	context,
	basicConfig = null,
}) => {
	const [list, setList] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);

	// get data based on the Template
	// STATIC_SITE template - we can't use storyblok api due to rate limit[ https://www.storyblok.com/docs/api/content-delivery#topics/rate-limit ]. So we are using blogList , we are making use of all the pages that are available at build time. and filtering blogs in transformers.
	// PREVIEW template - we will use API of storyblok , since preview build are not meant to be public useage. Also we dont have all pages available for preview build.
	useEffect(() => {
		if (process.env.GATSBY_TEMPLATE === "PREVIEW") {
			async function fetchData() {
				const { token } = context;
				let result = await getStoriesByContentType(
					contentType,
					token && token.private,
				);
				result = filterBlogsByCategories(result);
				let list = getBlogItemProps(result, basicConfig);
				list = sortNumberBy(list, "dateInMilliSec", ORDER_BY.ASCENDING);
				setList(list);
			}
			fetchData();
		} else {
			const list = filterBlogsByCategories(blogList);
			setList(list);
		}
	}, []);

	const renderBlogItem = () => {
		const start = (currentPage - 1) * blogsPerPage;
		const end = start + blogsPerPage;
		return list?.slice(start, end).map((blogItem, index) => {
			return (
				<BlogItem
					key={index}
					{...blogItem}
					allowTitleNavigation={allowTitleNavigation}
				></BlogItem>
			);
		});
	};

	const onPageChanged = ({ currentPage }) => {
		setCurrentPage(currentPage);
	};

	return (
		<BlogListWrapper>
			<Heading>{header}</Heading>
			{renderBlogItem()}
			<Pagination
				totalRecords={list?.length}
				pageLimit={blogsPerPage}
				onPageChanged={onPageChanged}
			/>
		</BlogListWrapper>
	);
};

export default BlogList;
